import { createFileRoute } from "@tanstack/react-router";

import { OnboardingVoice } from "../../../features/onboarding/OnboardingVoice";

export const Route = createFileRoute("/_app/onboarding/voice")({
  component: OnboardingVoice,
});
